import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import QuoteFormFull from "@/components/forms/QuoteFormFull";

export default function Quote() {
  return (
    <>
      <SEO
        title="Get a Free Life Insurance Quote | 1907 Insurance Group"
        description="Request a personalized life insurance quote in about two minutes. Final expense, term, and whole life options compared by an independent licensed agent."
      />
      <PageHero
        eyebrow="Get a Quote"
        title="Tell Us What You Want to Protect"
        intro="This short form takes about two to four minutes. Michael will review your answers personally and follow up with options that fit your needs, health, and budget."
      />
      <section className="py-14 md:py-20" data-testid="quote-page-form">
        <div className="container-site max-w-3xl">
          <Reveal>
            <QuoteFormFull />
          </Reveal>
          <p className="mt-6 text-sm text-mutedink leading-relaxed">
            Prefer to talk instead? Call (877) 833-1907 and Michael will take the same information by phone.
          </p>
        </div>
      </section>
    </>
  );
}
